import { Navigate, useLocation } from 'react-router-dom';
import { AppShell } from '../layouts/AppShell';
import { useAuthStore } from '../lib/auth-store';

/**
 * Protected layout route:
 *   - waits for the /auth/me probe to settle
 *   - redirects to /login if unauthenticated
 *   - otherwise renders the AppShell which hosts the matched child via <Outlet />
 */
export function ProtectedRoute() {
  const user = useAuthStore((s) => s.user);
  const initialized = useAuthStore((s) => s.initialized);
  const location = useLocation();

  if (!initialized) {
    return (
      <div className="auth-wrap">
        <div className="muted">Loading…</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <AppShell />;
}
